import {FC} from 'react';
import * as _ from 'lodash';
import * as marked from 'marked';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import {findFieldsNode, toHTML} from '~/utils';

const FAQAccordions = ({
  faqs,
  categoryName,
}: {
  faqs: [any];
  categoryName: string;
}) => {
  const preExpanded = _.get(faqs, '[0].id');
  const getValue = (data: any, key: any) => {
    return _.get(findFieldsNode(data, key), 'value');
  };
  return (
    <div className="single-faq">
      <h4>{categoryName}</h4>
      <Accordion
        preExpanded={[preExpanded]}
        allowZeroExpanded
        allowMultipleExpanded
      >
        {_.map(faqs, (item, index) => {
          return (
            <AccordionItem
              uuid={_.get(item, 'id')}
              key={`item-acc-${index}-${_.get(item, 'id')}`}
            >
              <AccordionItemHeading>
                <AccordionItemButton>
                  <span>{getValue(item, 'name')}</span>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p
                  dangerouslySetInnerHTML={{
                    __html: toHTML(getValue(item, 'full_answer')),
                  }}
                  className="prose dark:prose-invert "
                ></p>
              </AccordionItemPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
};

export default FAQAccordions;
